<template>
  <div id="user-profile">
    <div class="container">
      <!-- Card -->
      <div class="card testimonial-card pt-4">
        <!-- Background color -->
        <div class="card-up indigo lighten-1"></div>

        <!-- Avatar -->
        <div
          class="avatar mx-auto white text-info"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
            width: 200px;
            overflow: hidden;
            border-radius: 50%;
          "
        >
          <label calss="profi-lab d-block" for="profi" style="cursor: pointer">
            <input type="file" class="d-none" />
            <img
              :src="profile"
              class="rounded-circle"
              alt="avatar"
              style="width: 200px"
            />
            <i class="fas fa-pencil-alt" aria-hidden="true"></i>
          </label>
        </div>
        <div class="d-flex justify-center">
          <input
            class="btn btn-primary text-center btn-rounded mx-auto"
            type="button"
            value="save"
          />
        </div>

        <!-- Content -->
        <div class="card-body">
          <!-- Name -->
          <h4 class="card-title">{{ fullname }}</h4>
          <hr />

          <div class="modifWrapper row">
            <!-- Material input -->
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-6">
                  <div class="md-form ml-0 mr-0">
                    <input
                      id="firstname"
                      type="text"
                      v-model.trim="firstname"
                      class="form-control ml-0"
                    />
                    <label for="firstname" class="active">Firstname</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="md-form ml-0 mr-0">
                    <input
                      id="lastname"
                      type="text"
                      v-model.trim="lastname"
                      class="form-control ml-0"
                    />
                    <label for="lastname" class="active">Lastname</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 m-auto">
              <button class="btn blue-gradient btn-rounded btn-block">
                enregistrer<i
                  class="ml-2 fas fa-pencil-alt"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
            <div class="col-md-8">
              <div class="md-form ml-0 mr-0">
                <input
                  id="email"
                  type="email"
                  v-model.trim="email"
                  class="form-control ml-0"
                />
                <label for="email" class="active">Email</label>
              </div>
            </div>
            <div class="col-md-4 m-auto">
              <button class="btn blue-gradient btn-rounded btn-block">
                enregistrer<i
                  class="ml-2 fas fa-pencil-alt"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
            <div class="col-md-8">
              <div class="md-form mt-2">
                <input
                  class="form-control"
                  type="date"
                  id="dateNaissProfile"
                  v-model="birthday"
                />
                <label for="dateNaissProfile">La date de naissance</label>
              </div>
            </div>
            <div class="col-md-4 m-auto">
              <button class="btn blue-gradient btn-rounded btn-block">
                enregistrer<i
                  class="ml-2 fas fa-pencil-alt"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
            <!-- <div class="col-md-4 m-auto">
                <button class="btn blue-gradient btn-rounded btn-block">
                  enregistrer<i
                    class="ml-2 fas fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                </button>
              </div> -->

            <div class="col-md-8">
              <div class="md-form ml-0 mr-0">
                <input
                  id="address"
                  type="text"
                  v-model.trim="address"
                  class="form-control ml-0"
                />
                <label for="address" class="active">Address</label>
              </div>
            </div>
            <div class="col-md-4 m-auto">
              <button class="btn blue-gradient btn-rounded btn-block">
                enregistrer<i
                  class="ml-2 fas fa-pencil-alt"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
            <div class="col-md-8">
              <div class="md-form ml-0 mr-0">
                <input
                  id="phone_number"
                  type="text"
                  v-model.trim="phone_number"
                  class="form-control ml-0"
                />
                <label for="phone_number" class="active">Phone number</label>
              </div>
            </div>
            <div class="col-md-4 m-auto">
              <button class="btn blue-gradient btn-rounded btn-block">
                enregistrer<i
                  class="ml-2 fas fa-pencil-alt"
                  aria-hidden="true"
                ></i>
              </button>
            </div>

            <div class="col-md-8">
              <div class="md-form">
                <i class="fas fa-pencil-alt prefix active"></i>
                <textarea
                  class="md-textarea form-control"
                  rows="3"
                  id="descProf"
                ></textarea>
                <label for="descProf">décrivez-vous (optionnelle)</label>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- update account -->
            <div class="col-md-12 mb-2">
              <button class="btn blue-gradient btn-rounded btn-block my-2">
                Update changes
                <i class="fa fa-key ml-2" aria-hidden="true"></i>
              </button>
            </div>

            <!-- change password -->
            <div class="col-md-12 mb-2">
              <button
                class="btn aqua-gradient btn-rounded btn-block my-2"
                data-toggle="modal"
                data-target="#modalLoginAvatar3"
              >
                changer le mot de passe
                <i class="fa fa-key ml-2" aria-hidden="true"></i>
              </button>
            </div>

            <div class="col-md-12">
              <button
                class="btn peach-gradient btn-rounded btn-block"
                data-toggle="modal"
                data-target="#modalLoginAvatar4"
              >
                supprimer mon compte
                <i class="ml-2 fas fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Card -->
    </div>

    <!--Modal: pass change-->
    <div
      class="modal fade"
      id="modalLoginAvatar3"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog cascading-modal modal-avatar modal-sm"
        role="document"
      >
        <!--Content-->
        <div class="modal-content">
          <!--Header-->
          <div class="modal-header">
            <img
              :src="profile"
              alt="avatar"
              class="rounded-circle img-responsive"
            />
          </div>
          <!--Body-->
          <div class="modal-body text-center mb-1">
            <h5 class="mt-1 mb-2">Change password</h5>

            <div class="md-form ml-0 mr-0">
              <input
                id="oldPass"
                type="password"
                class="form-control form-control-sm ml-0"
                v-model="change_password.actualPassword"
              />
              <label for="oldPass" class="ml-0">Actual password</label>
            </div>
            <div class="md-form ml-0 mr-0">
              <input
                id="newPass"
                type="password"
                v-model="change_password.newPassword"
                class="form-control form-control-sm ml-0"
              />
              <label for="newPass" class="ml-0">New password</label>
            </div>

            <div class="text-center mt-4">
              <button @click="changePassword()" class="btn btn-primary mt-1">
                Confirm<i class="fa fa-sign-in ml-1"></i>
              </button>
            </div>
          </div>
        </div>
        <!--/.Content-->
      </div>
    </div>
    <!--Modal: pass change-->

    <!--Modal: supp compte-->
    <div
      class="modal fade"
      id="modalLoginAvatar4"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog cascading-modal modal-avatar modal-sm"
        role="document"
      >
        <!--Content-->
        <div class="modal-content">
          <!--Header-->
          <div class="modal-header">
            <img
              :src="profile"
              alt="avatar"
              class="rounded-circle img-responsive"
            />
          </div>
          <!--Body-->
          <div class="modal-body text-center mb-1">
            <h5 class="mt-1 mb-2 text-danger">Delete account !</h5>

            <div class="md-form ml-0 mr-0">
              <input
                type="password"
                v-model="delete_password.password"
                class="form-control form-control-sm ml-0"
                id="passDel"
              />
              <label for="passDel" class="ml-0">Password</label>
            </div>

            <div class="text-center mt-4">
              <button class="btn btn-primary mt-1" @click="deleteAccount()">
                Confirm<i class="fa fa-sign-in ml-1"></i>
              </button>
            </div>
          </div>
        </div>
        <!--/.Content-->
      </div>
    </div>
    <!--Modal: sup compte-->
  </div>
</template>

<script>
const { auth } = require("@/firebase");
const axios = require("axios");
import swal from "sweetalert";

export default {
  name: "UserProfile",
  data() {
    return {
      firstname: "",
      lastname: "",
      profile: "",
      email: "",
      password: "",
      address: "",
      birthday: "",
      phone_number: "",
      ssn: "",
      change_password: {
        actualPassword: "",
        newPassword: "",
      },
      delete_password: {
        password: "",
      },
    };
  },
  computed: {
    fullname() {
      return this.firstname + " " + this.lastname;
    },
  },
  mounted() {
    axios
      .get(`/api/users/${auth.currentUser.uid}`)
      .then((user) => {
        var currentUser = user["data"];
        this.firstname = currentUser.firstname;
        this.profile = currentUser.profile;
        this.lastname = currentUser.lastname;
        this.email = currentUser.email;
        this.address = currentUser.address;
        this.ssn = currentUser.number_id;
      });
  },
  methods: {
    changePassword() {
      auth
        .signInWithEmailAndPassword(
          auth.currentUser.email,
          this.change_password.actualPassword
        )
        .then((userCredentiels) => {
          userCredentiels.user
            .updatePassword(this.change_password.newPassword)
            .then(() => {
              swal("Success", "Password changed successfully", "success");
            })
            .catch((error) => {
              swal("Oops", error.toString(), "error");
            });
        })
        .catch((error) => {
          swal("Oops", error.toString(), "error");
        });
    },
    deleteAccount() {
      auth
        .signInWithEmailAndPassword(
          auth.currentUser.email,
          this.delete_password.password
        )
        .then((userCredentiels) => {
          userCredentiels.user
            .delete()
            .then(() => {
              swal("Success", "Account deleted successfully", "success");
            })
            .catch((error) => {
              swal("Oops", error.toString(), "error");
            });
          // User re-authenticated.
        })
        .catch((error) => {
          swal("Oops", error.toString(), "error");
        });
    },
  },
};
</script>
<style lang="scss">
.testimonial-card {
  .card-body h4 {
    text-align: center;
  }
  .avatar {
    position: relative;
    text-shadow: 0px 0px 11px black;
    i {
      position: absolute;
      font-size: 3em;
      bottom: 0;
      position: absolute;
      right: 25px;
    }
  }
}
</style>